module.exports = __webpack_public_path__ + "static/media/logoA2B.387b8ef7.jpg";